type PrefillControl = Element & { value?: unknown; currentValue?: unknown };

export function prefillFormControl(input: Element, value: unknown, emitEvents = true): void {
  // These controls render from formValues; raw .value/events corrupt their typed bindings.
  if ((input instanceof HTMLSelectElement && input.multiple)
      || (input instanceof HTMLInputElement && input.type === 'datetime-local')) return;
  const control = input as PrefillControl;
  if (control.value === value) return;
  control.value = value;
  if (control.currentValue !== undefined) control.currentValue = value;
  if (emitEvents) {
    input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
  }
}

// Generated by Copilot
// updated on: 2026-10-14 | 10 lines added | [Auto Generated] | Extract existing DOM prefill for native-control regression coverage | Time Taken 3 min
// Generated by Copilot
// updated on: 2026-10-14 | 3 lines added | [Auto Generated] | Preserve renderer-bound multiselect and datetime prefills | Time Taken 3 min
// Generated by Copilot
// updated on: 2026-10-26 | 5 lines added / 3 removed | [Auto Generated] | Allow silent server prefill without firing user change handlers | Time Taken 2 min
